import { DynamicToolUIPart, ToolUIPart } from 'ai';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { I18nNamespace } from '~/common/types';

interface GenericToolProps {
  tool: ToolUIPart<any> | DynamicToolUIPart;
}

export const GenericTool = ({ tool }: GenericToolProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'Chat.tools.common' });
  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`loading`)} />;
    case 'output-available':
    case 'output-error':
    default:
      return null;
  }
};
